<template>
  <div>
    <v-layout align-center>
      <v-text-field
        label="Поиск по слову/дате"
        class="ma-0"
      />
      <v-spacer />
      <v-btn
        :disabled="disabled"
        color="primary"
        small
        icon
        @click="showMessageDialog"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="disabled || isDisableMarkAsRead || loading"
            color="primary"
            small
            icon
            :loading="loadingMarkAsRead"
            v-on="on"
            @click="markAllAsRead"
          >
            <v-icon>playlist_add_check</v-icon>
          </v-btn>
        </template>
        <span>Отметить все как прочитанные</span>
      </v-tooltip>
      <v-dialog
        v-model="messageDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="message"
                label="Сообщение"
              />

              <v-btn
                :loading="loading"
                small
                color="primary"
                @click="addMessage"
              >
                Ок
              </v-btn>
              <v-btn
                small
                @click="messageDialog = false"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <div
      class="pa-1 messages-list"
      :style="{
        height: blockMessageHeight + 'px',
        'overflow-y': 'auto',
        'overflow-x': 'hidden'
      }"
    >
      <v-list>
        <v-list-tile
          v-for="item in chat"
          :key="item.id"
          :style="getNodeStyle(item.node)"
          :class="['compact', !item.isReaded ? 'blue lighten-5' : '']"
        >
          <v-list-tile-content
            :class="{
              'blue--text': item.author.id !== userRoles.Admin && item.isReaded
            }"
          >
            <div>{{ item.text }}</div>
            <v-list-tile-sub-title color="red">
              <v-layout>
                {{ getAuthors(item) }}
                {{ item.date | dateTime }}
              </v-layout>
              <v-layout>
                <span class="pr-1">
                  {{
                    item.readedContactPerson
                      ? item.readedContactPerson.title
                      : ""
                  }}
                </span>
                <span>
                  {{
                    item.readedContactPerson && item.readedDate
                      ? $options.filters.dateTime(item.readedDate)
                      : ""
                  }}
                </span>
              </v-layout>
              <v-divider class="my-0 ml-0 mr-1 white" />
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
  </div>
</template>
<script>
import {
  addShippingMessage,
  markAsReadMessage,
  markAllMessagesAsRead,
} from "../../../../backend/shippingsApi.js";
import { userRoles } from "../../../../enums/user-roles.js";
import auth from "../../../../auth.js";

export default {
  props: ["id", "disabled", "blockHeight", "user"],
  data() {
    return {
      messageList: [],
      messageDialog: false,
      message: "",
      loading: false,
      loadingMarkAsRead: false,
    };
  },
  computed: {
    chat() {
      this.messageList = [];
      this.messages.forEach((item, index) => {
        const count = 0;
        item.node = `${index}-${count}`;

        this.$set(this.messageList, index, item);
        if (item.children) {
          this.getMessageListItem(item.children, index, count + 1);
        }
        if (this.isAdmin || this.shippingManager.id !== this.user.employeeId) {
          item.isReaded = true;
        } else if (this.shippingManager.id === this.user.employeeId) {
          if (item.author.id === this.user.id) {
            item.isReaded = true;
          }
        }
      });
      return this.messageList;
    },
    blockMessageHeight() {
      if (this.blockHeight) {
        return this.blockHeight;
      }
      return window.innerHeight - 545;
    },
    messages() {
      return this.$store.getters["shipping/messages"];
    },
    userRoles() {
      return userRoles;
    },
    isAdmin() {
      return auth.isAdmin();
    },
    shippingManager() {
      return this.$store.getters["shipping/manager"];
    },
    isDisableMarkAsRead() {
      if (this.shippingManager?.id !== this.user?.employeeId) {
        return true;
      } else if (
        this.shippingManager?.id === this.user?.employeeId &&
        !!(this.chat.length && this.chat.find(i => !i.isReaded))
      ) {
        return false;
      } else if (
        this.shippingManager?.id === this.user?.employeeId &&
        (!this.chat.length ||
          (this.chat.length && !this.chat.find(i => !i.isReaded)))
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getMessageListItem(item, index, count) {
      if (!item) {
        return;
      }
      item.node = `${index}-${count}`;
      this.messageList.push(item);
      if (item.children) {
        this.getMessageListItem(item.children, index, count + 1);
      }
    },
    getNodeStyle(node) {
      return { paddingLeft: node.slice(-1) * 10 + "px" };
    },
    showMessageDialog() {
      if (!this.disabled) {
        this.messageDialog = true;
      }
    },
    async addMessage() {
      this.loading = true;
      await addShippingMessage(this.id, this.message);
      this.messageDialog = false;
      this.message = "";
      this.loading = false;
      await this.$store.dispatch("shipping/getMessages");
    },
    getAuthors(item) {
      return item.authorContactPerson ? item.authorContactPerson.title : "";
    },
    async markAsRead(itemId) {
      await markAsReadMessage(this.id, itemId);
      await this.$store.dispatch("shipping/getMessages");
    },
    async markAllAsRead() {
      this.loadingMarkAsRead = true;
      await markAllMessagesAsRead(this.id);
      await this.$store.dispatch("shipping/getMessages");
      this.loadingMarkAsRead = false;
    },
  },
};
</script>
